var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStickyNote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffba55;}.cls-2{fill:#fc6;}.cls-3{fill:#ffde76;}.cls-4{fill:#db5669;}.cls-5{fill:#f26674;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sticky note") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sticky_note",
    "data-name": "sticky note"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4,
    y: 4,
    width: 40,
    height: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44,4V7H9A3,3,0,0,1,6,4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44 9 44 39 36 47 4 47 4 9 44 9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44,9V39l-6,6H10a4,4,0,0,1-4-4V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39,18H9a1,1,0,0,1,0-2H39A1,1,0,0,1,39,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39,24H9a1,1,0,0,1,0-2H39A1,1,0,0,1,39,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39,30H9a1,1,0,0,1,0-2H39A1,1,0,0,1,39,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,36H9a1,1,0,0,1,0-2H24A1,1,0,0,1,24,36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "44 39 36 47 36 39 44 39"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 21,
    y: 1,
    width: 6,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M27,1c0,8.55-.1,8,0,8a4,4,0,0,1-4-4V1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyNote);
export default __webpack_public_path__ + "static/media/stickyNote.5fd2b550925cc2f9dd08e239bd3d3fad.svg";
export { ForwardRef as ReactComponent };